import styled from "styled-components";

const FilterProductType = styled.ul`
  --svg-size: 20px;

  &:hover {
    rect {
      stroke: ${({theme}) => theme.colors.gray4};
    }
  }

  .filter-product-type__header {
    display: flex;
    align-items: baseline;
  }

  .filter-product-type__heading {
    color: ${({theme}) => theme.colors.brandDark};
    font-family: var(--font-NHaasGroteskDSPro-65Md);
    font-size: 20px;
    line-height: 24px;
  }

  .filter-product-type__clear {
    margin-left: auto;
    color: ${({theme}) => theme.colors.gray3};

    &:hover,
    &:focus {
      color: ${({theme}) => theme.colors.brand};
    }
  }

  .filter-product-type__show {
    margin-top: .875rem;
    margin-left: 8px;
    flex: 1 1 100%;

    @media (max-width: 859px) {
      margin-left: .5rem;
    }
  }

  .filter-product-type__show-button {
    padding: 3px;
    border: 1px solid ${({theme}) => theme.colors.brandDark};
    color: ${({theme}) => theme.colors.brandDark};
    width: 110px;
    height: 24px;
    text-align: center;
    font-weight: normal;
    
    &:hover,
    &:focus {
      border-color: ${({theme}) => theme.colors.brand};
      color: ${({theme}) => theme.colors.brand};
    }
  }

  .filter-product-type__add {
    margin-left: auto;
    width: 16px;
    height: 16px;
    stroke: ${({theme}) => theme.colors.gray4};
    border: 1px solid ${({theme}) => theme.colors.gray2};
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &:hover,
    &:focus {
      border-color: ${({theme}) => theme.colors.brand};
      background-color: ${({theme}) => theme.colors.brand};
      stroke: ${({theme}) => theme.colors.white};
    }

    svg {
      width: 10px;
      height: 10px;
      stroke: inherit;
    }
  }

  .filter-product-type__type {
    width: 100%;
    display: inline-flex;
    align-content: center;
    flex-direction: column;

    @media (max-width: 859px) {
      &:not(:first-of-type) {
        margin-top: .75rem;
      }
    }
    @media (min-width: 860px) {
      &:not(:first-child) {
        margin-top: .75rem;
      }
    }
  }
  
  .filter-product-type__sub-category {
    margin-left: 15px;
    li {
      margin-top: .75rem;
    }
  }

  .filter-product-type__checkbox {
    padding: .125rem 8px;
    border-radius: 50px;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    cursor: pointer;
    transition: var(--button-transition);
    width: 180px;
    
    &.is-checked {
      background-color: ${({theme}) => theme.colors.highlight};
    }

    &:hover,
    &:focus {
      background-color: ${({theme}) => theme.colors.highlight};
    }

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
  }


  .filter-product-type__checkbox__custom {
    position: relative;
    height: 15px;
    width: 15px;
    flex-shrink: 0;
    path {
      transform: translate(5px, 3px);
    }
  }
  
  .filter-product-type__checkbox__svg-checked {
    padding: 1px;
  }

  .filter-product-type__checkbox__copy {
    margin-left: 8px;
    color: ${({ theme }) => theme.colors.gray4};
    font-family: var(--font-NHaasGroteskDSPro-55Rg);
  }
  
  .filter-product-type__checkbox-border {
    width:15px; 
    height: 15px; 
    border: 1px solid ${({theme}) => theme.colors.brandDark};
    border-radius: 1px;
  }

  .input-search {
    height: 36px;
    display: flex;
    width: 192px;
    
    @media (min-width: 860px) {
      margin-top: 1rem;
    }
  }

  .input-search__input {
    height: 25px;
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.brandDark};
    outline: none;
    margin-left: 4px;
    padding-right: 16px;

    &::placeholder {
      color: ${({ theme }) => theme.colors.gray3}
    }

    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.colors.brand}
    }
  }

  .input-search__icon {
    width: 24px;
    flex-shrink: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-right: none;
    border-radius: 16px 0 0 16px;

    svg {
      width: 16px;
      height: 16px;
      box-sizing: content-box;
      fill: ${({theme}) => theme.colors.brandDark};
    }
  }

  .input-search__button {
    padding: 3px;
    color: ${({theme}) => theme.colors.brandDark};
    width: 81px;
    height: 24px;
    text-align: center;
    font-weight: normal;
    margin-left: -16px;

    &:hover,
    &:focus {
      fill: ${({ theme }) => theme.colors.brand};
    }

    svg {
      width: 12px;
      height: 12px;
      box-sizing: content-box;
      fill: ${({theme}) => theme.colors.brandDark};
    }
  }

  .nav-link {
    font-size: var(--type-scale-16);
    text-decoration: none;
  }
`;

export default FilterProductType;